import { api } from './client';
import { Product } from './products';

export interface OrderItem {
  product_id: string;
  quantity: number;
  unit_price: number;
  total: number;
}

export interface Order {
  id: number;
  user_id: number | null;
  order_number: string;
  type: 'direct' | 'quote';
  status: 'pending' | 'confirmed' | 'processing' | 'shipped' | 'delivered' | 'cancelled';
  items: OrderItem[];
  form_data: Record<string, string>;
  total_amount: number;
  created_at: string;
  updated_at?: string;
}

export interface CreateOrderRequest {
  items: OrderItem[];
  form_data?: Record<string, string>;
}

export const ordersApi = {
  createOrder: (data: CreateOrderRequest) =>
    api.post<Order>('/orders/', data),

  getOrders: () =>
    api.get<Order[]>('/orders/'),

  getOrder: (id: number) =>
    api.get<Order>(`/orders/${id}/`),

  updateOrderStatus: (id: number, status: string) =>
    api.patch<Order>(`/orders/${id}/status/`, { status }),
};
